import { SpaceBetween, Box, StatusIndicator, Spinner, Button } from "@cloudscape-design/components";
import { useEffect, useState } from "react";
import deploymentService from "services/deploymentService";
import { ClusterExtensionLogObjectType } from "types/extensionTypes";
import { formatDateTime } from "utils/Utils";




function ClusterExtensionLogs({clusterId, triggerRefreshLogs}:{clusterId:string, triggerRefreshLogs:boolean}) {

    const [logsList, setLogsList] = useState<ClusterExtensionLogObjectType[]>([]);

    const [loadingLogs, setLoadingLogs] = useState(false);

    const [errorLoadingLogs, setErrorLoadingLogs] = useState<string | null>(null);




    const fetchClusterExtensionLogs = async()=>{
        try {
            setLoadingLogs(true);
            setErrorLoadingLogs(null);
            
            const result = await deploymentService.getClusterExtensionLogs(clusterId);
            setLogsList(result);

        } catch (error) {
            console.error("failed to fetch cluster extension logs.");
            setErrorLoadingLogs("Failed to load logs.");

        } finally{
            setLoadingLogs(false);
        }
    }

    useEffect(()=>{
        fetchClusterExtensionLogs();
    },[triggerRefreshLogs])





    if(loadingLogs){
        return (
            <Box textAlign="center">
                <SpaceBetween size="s">
                    <Spinner size="normal" />
                    <Box color="text-body-secondary">
                        Loading activity...
                    </Box>
                </SpaceBetween>
            </Box>
        )
    }
    
    if(errorLoadingLogs){
        return (
            <Box textAlign="center">
                <SpaceBetween size="s">
                    <Box variant="h4" color="text-status-error">{errorLoadingLogs}</Box>

                    <Button onClick={fetchClusterExtensionLogs}>
                        Retry
                    </Button>
                </SpaceBetween>
            </Box>
        )
    }

    if(logsList.length === 0){
        return (
            <Box textAlign="center">
                <SpaceBetween size="s">
                    <Box variant="h4">No activity yet</Box>

                    <Box color="text-body-secondary">
                        Extension installation and removal events will appear here.
                    </Box>
                </SpaceBetween>
            </Box>
        )
    }

    return (
        <SpaceBetween size="xxxs">
            {logsList.map((log, index) => (
                <div key={index}>
                    <div className="flex gap-5">
                        
                        <StatusIndicator type={log.status === "successful" ? "success" : "error"} />

                        <SpaceBetween size="xxxs">
                            <div>
                                <span className="bold">{log.user?.firstName + " " + log.user?.lastName}</span> {log.action === "install" ? "installed" : "uninstalled"} <span className="bold">{log.extension?.displayName}</span>
                            </div>

                            <Box
                                variant="small"
                                color="text-status-inactive"
                            >
                                {formatDateTime(log.createdAt)}
                            </Box>
                        </SpaceBetween>
                    </div>

                    <hr />
                </div>
            ))}
        </SpaceBetween>
    )
}

export default ClusterExtensionLogs
